import { apiCall } from "../../../service/api-service.js";

//Master List
export const getMasterApi = async (params) => 
  apiCall("get", `template${params}`);

//Group List
export const getGroupApi = async (params) => 
  apiCall("get", `template_group${params}`);

// Save Group
export const saveGroupApi = async (data) => 
  apiCall("post", "template_group", data);

// Update Group
export const updateGroupApi = async (data, id) => 
  apiCall("put", `template_group/${id}`, data);

// Get Group Details
export const getGroupDetailsApi = async (id) => 
  (await apiCall("get", `template_group/${id}`)).data;

// Master Save

export const saveMasterApi = async (data) => 
  apiCall("post", "template", data);

//Master Update

export const UpdateMasterApi = async (data, id) => 
  apiCall("put", `template/${id}`, data);

//Master Edit

export const getMasterDetailsApi = async (id) => 
  (await apiCall("get", `template/${id}`)).data;

//Master Delete

export const getDeleteApi = async (deleteUrl) => 
  apiCall("delete", deleteUrl);
